//DESERTLAND.Content.Bibliography
import { Utils } from '../cals.utils';
// import { DESERTLAND } from '../desertland.init';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
// import { TemplateLoader } from '../desertland.templateLoader';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.data';
// import 'kendo-ui-core/js/kendo.mobile.listview';

declare var log, info, warn, groupCollapsed, groupEnd;

export class BibliographyContent {
  public page = ROUTES.BIBLIOGRAPHY;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-bibliography';
  public subNavId = '#bibliography_sub_nav';
  public biblioReady = false;
  public biblioRendered = false;
  public biblioSel = "#bibliography_list";
  public contentSel = '#bibliography_list_container';

  public init(params = {}) {
    groupCollapsed("Bibliography.init");

    if ($(this.container).length) {
      log("ready for " + this.page);
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log(this.page + " dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }

    if (App.data.biblio && App.data.biblio.length > 0) {
      info("biblio data ready", App.data.biblio);
      this.biblioReady = true;
    } else {
      info("biblio data not ready yet", App.data.biblio);
      this.biblioReady = false;
      // App.radio.subscribe('dataBiblioReady', this.onBiblioDataReady);
      App.service.load.biblio((data) => {
        //log("biblio loaded, listening to radio... %o", data);
        App.data.biblio = data;
        this.onBiblioDataReady();
        // App.radio('dataBiblioReady').broadcast(data).unsubscribe(DESERTLAND.Content.About.onBiblioDataReady);
      });
    }

    groupEnd("Bibliography.init");
  }

  public onBiblioDataReady() {
    groupCollapsed("About > Biblio > DataReady");
    log("onBiblioDataReady %o", App.data.biblio);
    this.biblioReady = true;
    if (!this.biblioRendered) {
      this.renderBiblio();
    }
    groupEnd("About > Biblio > Render");
  }

  public loadTpl(callback) {
    log(this.page + " > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      log(this.page + " > renderTpl", resp);
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#' + resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));

        this.loadContent();

        this.initEvents();

        if (!this.biblioRendered) {
          this.renderBiblio();
        }

      } else {
        info("no sel?");
      }
    });
  }

  public loadContent() {
    App.content.Learnmore.loadDataTheRenderSubnav(this.subNavId);
  }



  public renderBiblio = (data = {}) => {
    log("renderBiblio", data);

    // var me = DESERTLAND.Content.About,
    let $container = $(this.contentSel);

    if (!this.biblioReady || !this.biblioSel || !$container.length || !App.data.biblio || App.data.biblio.length < 1) {
      let s = "biblio not ready yet, waiting for: ";

      if (!this.biblioReady) { info(s + "!biblioReady"); }
      if (!this.biblioSel) { info(s + "!biblioSel"); }
      if (!$container.length) { info(s + "!sel.len"); }
      if (!App.data.biblio) { info(s + "!data.biblio", App.data.biblio); }

    } else {
      info("ok, ready", App.data.biblio);

      let $el = $container.find(this.biblioSel);

      // info("biblio here: ", this.biblioSel, $el);

      if ($el.length) {

        /* 
        <div class="container">
        
        <button class="btn btn-collapse action__collapse-biblio" type="button" data-toggle="collapse" data-target="#collapseBiblio" aria-expanded="false" aria-controls="collapseBiblio">
            Full Biblio
        </button>
        <div class="collapse" id="collapseBiblio">
            <div class="biblio-list">Full Biblio (Accordion of Biblios)</div>
        </div>
        </div>
        
        */
        let wrap = $("<div></div>").addClass('biblio-wrap'),

          btn = $("<button></button>").addClass('btn btn-collapse action__collapse-biblio').attr({
            'type': "button",
            'data-toggle': "collapse",
            'data-target': "#collapseBiblio",
            'aria-expanded': "true",
            'aria-controls': "collapseBiblio"
          }).text("Full Biblio").appendTo(wrap),

          collapseEl = $("<div></div>").attr({ id: 'collapseBiblio' }).addClass('collapse in').appendTo(wrap),
          listEl = $("<div></div>").addClass('biblio-list').appendTo(collapseEl);

        $("<span></span>").addClass('caret icon-indicator').appendTo(btn);

        // author
        // date
        // description
        // image
        // location
        // nid
        // title

        let itemTpl = '<div class="biblio-item clearfix" data-nid="#= nid #">'
          + '<div class="image" style="background-image:url(\'#= Config.img_url.resource ##= image #\');"></div>'
          + '<h4 class="title">#= title #</h4>'
          + '<h5 class="author">#= author #</h5>'
          + '<div class="description">#= description #</div>'
          + '<div class="date">#= date #</div>'
          + '<div class="location">#= location #</div>'
          + '</div>';



        for (let i = 0; i < App.data.biblio.length; i++) {
          let templateData = App.data.biblio[i];
          templateData.Config = App.config;
          let template = kendo.template(itemTpl),
            result = template(templateData);
          listEl.append(result);
        }

        // add the bottom close button
        $("<button></button>").addClass('btn btn-collapse action__collapse-biblio text-center').attr({
          'type': "button",
          'data-toggle': "collapse",
          'data-target': "#collapseBiblio",
          'aria-expanded': "true",
          'aria-controls': "collapseBiblio"
        }).text("Close").appendTo(collapseEl);



        $el.append(wrap);



      } else {
        info("no biblioSel $el");
      }
    }
  }


  public initEvents() {

    if ($("#bibliography_print").length) {
      $("#bibliography_print").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        log("bibliography_print click");
      });
    }

    if ($("#bibliography_online").length) {
      $("#bibliography_online").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        log("bibliography_online click");
      });
    }

  }





}
